import React from 'react';
import { Link } from 'react-router';

import Logo from '../../components/Logo';

import WelcomeHero from './welcome.png';
import FindYourAdvisor from './find-your-advisor.svg';
import ChooseAService from './choose-a-service.svg';
import ScheduleATime from './schedule-a-time.svg';
import ReachYourGoals from './reach-your-goals.svg';

import './style.scss';

class Welcome extends React.Component {
  getBackground() {
    return <div className="welcome__background" />;
  }

  getLogo() {
    return (
      <div className="welcome__logo">
        <Logo />
      </div>
    );
  }

  getHowItWorks() {
    return (
      <div className="welcome__how-it-works">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="welcome__how-it-works-title">
                <span>How It Works</span>
              </div>
            </div>
          </div>

          <div className="row welcome__how-it-works-grid">
            <div className="col-sm-3 welcome__cell">
              <div className="welcome__icon">
                <img src={FindYourAdvisor} />
              </div>
              <div className="welcome__title">Choose your advisor</div>
              <div className="welcome__subtitle">
                Select from a personalized list of advisors just for you
              </div>
            </div>
            <div className="col-sm-3 welcome__cell">
              <div className="welcome__icon">
                <img src={ScheduleATime} />
              </div>
              <div className="welcome__title">Schedule a time</div>
              <div className="welcome__subtitle">
                Your advisor will reach out to you within 24 hours
              </div>
            </div>
            <div className="col-sm-3 welcome__cell">
              <div className="welcome__icon">
                <img src={ChooseAService} />
              </div>
              <div className="welcome__title">Get career advice</div>
              <div className="welcome__subtitle">
                Meet with your advisor via video chat and plan your career goals
              </div>
            </div>
            <div className="col-sm-3 welcome__cell">
              <div className="welcome__icon">
                <img src={ReachYourGoals} />
              </div>
              <div className="welcome__title">Reach your goals!</div>
              <div className="welcome__subtitle">
                Ace your interview and land your dream job!
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="welcome__get-started">
                <Link
                  className="btn btn-paragon-one"
                  to="/assessment/questions"
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getHero() {
    return (
      <div className="welcome__hero">
        <div className="container">
          <div className="row">
            <div className="col-sm-7">
              <img className="welcome__img" src={WelcomeHero} />
            </div>
            <div className="col-sm-5">
              <div className="welcome__text">
                Get an amazing job with help from successful experts
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.getBackground()}
        {this.getLogo()}
        {this.getHero()}
        {this.getHowItWorks()}
      </div>
    );
  }
}

export default store => ({
  path: 'welcome',
  component: Welcome,
});



// WEBPACK FOOTER //
// ./src/routes/assessment/routes/Welcome/index.js